var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"}},[(_vm.isNotAdminRoute && _vm.loading)?_c('loading-component'):_vm._e(),_c('router-view',{attrs:{"hidden":_vm.isNotAdminRoute && _vm.loading}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }